export default {
  performed_work: "Performed work successfully submitted!",
  mandatory_fields_empty: "The mandatory fields can not be empty",
  issue_raised: "The Issue was raised successfully!",
  issues_raised: "All Issues were raised successfully!",
  issue_removed_from_work_order: "The Issue was removed from the Work Order.",
  all_raised: "Work Performed and Issues raised successfully!",
  unsubmitted_work: "Your work is saved in “Unsubmitted Work”!",
  removed_todo: "Removed <i>{removedItem}</i>",
  deselected_previous_selection: "Your selections were deselected.",
  direct_notification: "A notification from",
  new_notification: "You have a new notification.",
  maintenance: "Maintenance Scheduled",
  assigned_work_order: "Assigned you to a Work Order",
  commented_work_order: "Commented on Work Order",
  commented_performed_work: "Commented on your Performed Work",
  rejected_issue: "Rejected your Issue",
  rejected_work: "Rejected your Work",
  accepted_work: "Accepted your Work",
  corrected_issue: "Corrected an Issue you raised",
  added_issue: "Added your Issue to a Work Order",
  default_event_name: "Event occurred",
  event_start: "starting",
  time_period: "minutes",
  identify_propose: "<b>Identifier</b> proposed",
  identify_associated: "<b>Identifier</b> associated",
  identify_association_changed: "<b>Identifier</b> association changed!",
  identify_dissociate: "<b>Identifier</b> disassociated!",
  identifier_already_associated: "The identifier is already associated with {entityDesignation}",
  not_implemented: "This feature has not been implemented yet.",
  saved_as_unsubmitted_work: "Saved as <b>Unsubmitted Work</b>",
  deleted_unsubmitted_work: "Deleted Unsubmitted Work",
  connection_lost: "Internet connection lost",
  connection_reestablished: "Internet connection re-established",
  photo_removed: "Photo removed",
  need_camera_permission:
    "The app needs to use your camera, but camera permission has not been granted.",
  need_file_system_permission:
    "The app needs to use your file storage, but file storage permission has not been granted.",
  file_size_exceeded:
    "The total size of the files you have selected exceeded {maxFileSize}MB, which is the maximum allowed size",
  file_type_not_allowed:
    "One or more files you have selected contained unaccepted file type. Allowed file types are {fileTypes}",
  files_not_accepted: "The following files were not accepted: {files}",
  files_empty: "Some of the files were empty. If this is a mistake, please try again.",
  file_empty: "The file is empty or corrupted. If this is a mistake, please try again.",
  corrective_work_not_allowed: "The work domain {workDomain} doesn't allow this action",
  regular_work_not_allowed: "There are no work domains on which work can be performed",
  corrective_work_already_exists:
    "A corrective work titled '{correctiveWorkTitle}' already exists on this Issue",
  bad_regular_work_guard: "There was a problem trying to resolve regular work creation",
  bad_corrective_work_guard: "There was a problem trying to resolve corrective work creation",
  bad_file_read: "Could not read file/s correctly. Please try again.",
  bad_file_download: "There was an issue while trying to download the file.",
  closed_issue: "Closed Issue without Correction",
  closed_corrected_issue: "Closed Corrected Issue",
  closed_work_order: "Work order closed",
  closed_completed_work_order: "Completed work order closed",
  issue_rejected: "Rejecting Issue",
  accept_corrective_work: "Accepted Corrective Work",
  rejected_corrective_work: "Rejected Corrective Work",
  data_fetched: "All data successfully fetched",
  issue_closed: "This <b>Issue</b> has already been closed!",
  issue_closed_success: "The issue closed successfully",
  work_order_corrective_closed_success: "The corrective work order closed successfully",
  work_order_regular_closed_success: "The regular work order closed successfully",
  regular_work_accepted: "The Regular Work has been accepted!",
  regular_work_rejected: "The Regular Work has been rejected!",
  corrective_work_accepted: "The Corrective Work has been accepted!",
  corrective_work_rejected: "The Corrective Work has been rejected!",
  issue_rejected_success: "The issue rejected successfully",
  issue_has_accepted_corrective_work: "This <b>Issue</b> has accepted Corrective Work",
  attachment_added: "<b>Attachment</b> added!",
  attachment_adding: "Adding <b>{name}</b>",
  unsubmitted_work_discarded: "Unsubmitted work discarded successfully",
  unsubmitted_work_on_issue_exists: "An Unsubmitted Corrective Work for this issue already exists!",
  image_uploading: "Image is being uploaded...|Images are being uploaded...",
  batch_error_partial: "Not all entries submitted successfully: {entries}",
  batch_error_full: "Entries submission failed: {entries}",
  issue_has_multiple_user_interactions:
    "More than one user has interacted with this Issue. Hence it is not possible to delete this Issue",
  bad_issue_id:
    "We could not find the relevant Issue data. Please try again later or contact support",
  work_order_draft_created: "<b>Work Order</b> draft created!",
  work_order_updated: "<b>Work Order</b> updated!",
  item_added_to_work_order: "Item added to the regular work order successfully",
  issue_added_to_work_order: "Issue added to the corrective work order successfully",
  issue_changed_work_order: "Changed issue work order successfully",
  location_not_enabled: "Location services not enabled on device",
}
